import script from "./WalletData.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletData.vue?vue&type=script&setup=true&lang=ts"

import "./WalletData.vue?vue&type=style&index=0&id=f1f4ac20&lang=scss&scoped=true"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f4ac20"]])

export default __exports__